import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { signupReq } from "Requests/User.req";
import sha256 from "sha256";
import userStore from "stores/userStore";

const Signup = () => {
  const navigate = useNavigate();
  const user = userStore((state) => state);

  const [idInput, setIdInput] = useState("");
  const [nicknameInput, setNicknameInput] = useState("");
  const [pwInput, setPwInput] = useState("");
  const [pwConfirmInput, setPwConfirmInput] = useState("");

  const goToEntryPage = () => {
    navigate("/");
  };

  const trySignup = async () => {
    try {
      let id = idInput.trim();
      if (id.length === 0) {
        toast.error("아이디를 입력해주세요.");
        return;
      }

      let pw = pwInput.trim();
      if (pw.length === 0) {
        toast.error("비밀번호를 입력해주세요.");
        return;
      }

      let pwConfirm = pwConfirmInput.trim();
      if (pwConfirm !== pw) {
        toast.error("비밀번호가 일치하지 않습니다.");
        return;
      }

      let nickname = nicknameInput.trim();
      if (nickname.length === 0) {
        nickname = null;
      }

      const result = await signupReq(id, sha256(sha256(id) + pw), nickname);

      const { user: userInfo, token } = result;
      const { nickname: nNickname, autoGenerated } = userInfo;
      toast.success("회원가입이 완료되었습니다.");

      user.setUid(userInfo.uid);
      user.setNickname(nNickname);
      user.setAutoGenerated(autoGenerated);
      user.setToken(token);

      navigate("/");
      // navigate("/");
    } catch (err) {
      console.error(err);
      toast.error("오류가 발생했습니다.");
    }
  };

  return (
    <div className="login page">
      {/* <div className="mips">MIPS</div> */}
      <div className="label">회원가입 </div>
      <div className="input-container">
        <input
          className="main-input"
          type="text"
          placeholder="아이디"
          onChange={(e) => setIdInput(e.target.value)}
          value={idInput}
        />
        <input
          className="main-input"
          type="text"
          placeholder="닉네임 (옵션)"
          onChange={(e) => setNicknameInput(e.target.value)}
          value={nicknameInput}
        />
        <input
          className="main-input"
          type="password"
          placeholder="비밀번호"
          onChange={(e) => setPwInput(e.target.value)}
          value={pwInput}
        />
        <input
          className="main-input"
          type="password"
          placeholder="비밀번호 확인"
          onChange={(e) => setPwConfirmInput(e.target.value)}
          value={pwConfirmInput}
        />
      </div>
      <div className="main-btn-container">
        <button className="main-btn highlight" onClick={trySignup}>
          회원가입{" "}
        </button>
        <button className="main-btn unhighlight" onClick={goToEntryPage}>
          돌아가기
        </button>
      </div>
    </div>
  );
};

export default Signup;
